import React, { Component } from 'react'
import {
  APPLY_PROJECT_PATH,
  APPLY_ORGANIZATION_PATH,
  APPLY_DOCUMMENTS_PATH,
  APPLY_FINISHED_PATH
} from '../MainRoutes/constants'
import { Switch, Route } from 'react-router-dom'

import { SectionWrapper } from '../../components/Section';
import ProjectWelcome from './Steps/Project/Welcome'
import OrganizationWelcome from './Steps/Organization/Welcome'
import DocumentsWelcome from './Steps/Documents/Welcome'
import ProjectRoutes from './Steps/Project/Routes'
import OrganizationRoutes from './Steps/Organization/Routes'
import DocumentRoutes from './Steps/Documents/Routes'
import Finished from './Steps/Finished'

const supportPageOffset = window.pageYOffset !== undefined
const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
const getScrollTop = () => supportPageOffset
  ? window.pageYOffset
  : isCSS1Compat
    ? document.documentElement.scrollTop
    : document.body.scrollTop

class ApplicationsLayout extends Component {
  scrollRef = React.createRef()

  componentDidMount() {
    if (getScrollTop() > 100) {
      this.scrollIntoView()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.scrollIntoView()
    }
  }

  scrollIntoView() {
    this.scrollRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  render() {
    return (
      <div ref={this.scrollRef}>
        <Switch>
          <Route path={APPLY_PROJECT_PATH} component={ProjectWelcome} />
          <Route path={APPLY_ORGANIZATION_PATH} component={OrganizationWelcome} />
          <Route path={APPLY_DOCUMMENTS_PATH} component={DocumentsWelcome} />
        </Switch>
        <SectionWrapper>
          <Switch>
            <Route path={APPLY_PROJECT_PATH} component={ProjectRoutes} />
            <Route path={APPLY_ORGANIZATION_PATH} component={OrganizationRoutes} />
            <Route path={APPLY_DOCUMMENTS_PATH} component={DocumentRoutes} />
            <Route path={APPLY_FINISHED_PATH} component={Finished} />
          </Switch>
        </SectionWrapper>
      </div>
    )
  }
}

export default ApplicationsLayout
